import React, { useState, useEffect, Component } from 'react';
import Clone from 'clone';
import { connect } from 'react-redux'
import { AppSettings } from '../../configs'
import '../../assets/css/tor-template-list.css'
import $ from 'jquery'

import { DatePicker, Select, InputDecimal, DropDownMuti } from '../../components/core';
import { SecureGateRoute, BreadCrumb, DetailBotLogModal, PanelExpand } from '../../components';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import CustomDialog from '../../components/Notifications/Dialog';

import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import { AdjustmentService } from '../../services';
import { useHistory } from "react-router";
import PanelProductEdit from '../../components/PanelProductEdit';
import Storage from '../../configs/Storage'
//import { response } from 'express';
//import formFineAdjustTemplate from './Template/formFineAdjustTemplate'
import NotiAdjustmentData from './NotiAdjustmentData';

//import { useParams } from "react-router-dom";

// const objAdjustment = {
//     adjust_no: null,
//     adjust_date: "12/08/2021",
//     amount: 0,
//     approver_code: "",
//     approver_name: "",
//     approver_position: "",
//     create_by: "",
//     create_date: "",
//     currency: null,
//     department: "",
//     email: "",
//     explanation: null,
//     final_installment_flag: false,
//     installment_no: null,
//     is_sende_auto: false,
//     is_sende_auto_email: null,
//     is_sende_informal: false,
//     po_contract_no: "",
//     po_header_text: "",
//     procurement_method: "",
//     purchase_date: "",
//     purchase_no: "",
//     remark: "",
//     reserved_adjust_date: "",
//     reserved_adjust_no: "",
//     adjustment_id: 0,
//     status: null,
//     telephone: "",
//     update_by: null,
//     update_date: "",
//     vendor_code: "",
//     vendor_name: "",
// }

export default () => {
    const user = Storage.getUser();
    let { adjustId } = useParams();
    const [stateObjAdjustment, setStateObjAdjustment] = React.useState({});
    const [stateAdjustId, setStateAdjustId] = React.useState({});
    const history = useHistory();
    
    const [isOpenViewFile,setIsOpenViewFile] = React.useState(false);
    const [isOpenConfirmSend,setIsOpenConfirmSend] = React.useState(false);
    const [isOpenEditAdjustment,setIsOpenEditAdjustment] = React.useState(false);
    

    const [isPrintAdjust,setIsPrintAdjust] = React.useState(false);
    const [isPrintReservedAdjust,setIsPrintReservedAdjust] = React.useState(false);
    const [isOpenConfirmReject,setIsOpenConfirmReject] = React.useState(false);
    const [isOpenConfirmApprove,setIsOpenConfirmApprove] = React.useState(false);
    const [isOpenViewFileComplete,setIsOpenViewFileComplete] = React.useState(false);
    const [hasPrintHeader,setHasPrintHeader] = React.useState(true);
    const [openLoading,setOpenLoading] = React.useState(false);
    const [canEdit,setCanEdit] = React.useState(false);
    const [canApprove,setCanApprove] = React.useState(false);

    const [showEditor,setShowEditor] = React.useState(false);
    const [editorHtml,setEditorHtml] = React.useState('');

    React.useEffect(()=>{
        console.log('stateObjAdjustment',stateObjAdjustment)
    },[stateObjAdjustment])
    

    const [adjustTemplateData,setAdjustTemplateData] = React.useState({
        'date': '',
        'company_name': '',
        'amount': '',
        'amount_text': '',
        'approver_name': '',
        'approver_position': '',
        'org_unit': '',
        'org_unit_tel': '',
        'adjust_no':'',
        'str_adjust_date_th': '',
        'isSet':false,
        'draw':0
    });
    
    useEffect(() => {
        //setStateObjAdjustment({...objAdjustment});
        setStateAdjustId({...adjustId});
      
        if (adjustId != 0) {
            GetAdjustmentById(adjustId);
        }
        
      }, [])


      function GetAdjustmentById(adjustId) {

        try {

            AdjustmentService.getAdjustmentById(adjustId).then((response) => {
                console.log("getAdjustmentById");
                console.log(response);

                if(response === undefined || response === null || response === '')
                {
                    setOpenLoading(false);
                    msg.error("ไม่พบข้อมูล หรือ ไม่มีสิทธิเปิดรายการหนังสือแจ้งค่าปรับ");
                    history.push(`/NotiAdjustment`);

                }else{
                //let obj = Clone(stateObjAdjustment);


                setCanEdit((response.status === '' || response.status === 'DRAFT'|| response.status === 'REJECT'))
                setCanApprove((response.status === 'WAITFAPP' && response.current_employeeId === user.userName))
               
                    setAdjustTemplateData((previous)=>({...previous,

                        'adjust_no':response.adjust_no,
                        'str_adjust_date_th': toDateStringThai(response.adjust_date),
                        'date': toDateStringThai(response.fine_adjust_date),
                        'company_name': response.vendor_name,
                        'amount': setFormateMomey(response.amount),
                        'amount_text': thaiBaht(response.amount),
                        'approver_name': response.approver_name,
                        'approver_position': response.approver_position,
                        'org_unit': response.department,
                        'org_unit_tel': response.telephone,
                    }))
    
               
                    let html = response.fine_adjust_template ?? "";

                    if((response.status === '' || response.status === 'DRAFT'|| response.status === 'REJECT') === false || response.isReadonly === true)
                    {
                        //html = html.replaceAll('contenteditable="true"','contenteditable="false"');
                        html = html.split('contenteditable="true"').join('contenteditable="false"');

                        if(response.status === 'COMPLETE' )
                        {
                            html = html.replace("water-mark","").replace("water-mark-ie","");
                        }
                    } 

                    setEditorHtml(html);

                    setTimeout(()=>{
                        setStateObjAdjustment({
                            ...response,
                            //fine_adjust_template: html,
                            adjust_date: response.adjust_date? moment(response.adjust_date).format('DD/MM/YYYY'): '',
                            amount: setFormateMomey(response.amount),
                            reserved_adjust_date: response.reserved_adjust_date? moment(response.reserved_adjust_date).format('DD/MM/YYYY'): '',
                            fine_adjust_date: response.fine_adjust_date? moment(response.fine_adjust_date).format('DD/MM/YYYY'): '',
                        })
                       

                    },800)


                    setTimeout(()=>{
                        setAdjustTemplateData((previous)=>({...previous,
                            'isSet':true
                        }))
                    },800)
              
                }
            })
        } catch (e) {
            console.log(e);
            //showMessage("error", "System error.", true);
        }
    }

    const toBoolean = (value) =>{
        if (value === 1)
            return true
        else if (value === true)
            return true
        else
            return false
    }

    const  setFormateMomey = (value) =>{
        const numeral = require('numeral');
        return numeral(value).format("0,0.00")
    }

    const thaiBaht = (number) =>
    {
        if(number == undefined || number ==null)
        {
            return '';
        }
      //ตัดสิ่งที่ไม่ต้องการทิ้ง
      for (var i = 0; i < number.length; i++) {
        number = number.replace(",", ""); //ไม่ต้องการเครื่องหมายคอมมาร์
        number = number.replace(" ", ""); //ไม่ต้องการช่องว่าง
        number = number.replace("บาท", ""); //ไม่ต้องการตัวหนังสือ บาท
        number = number.replace("฿", ""); //ไม่ต้องการสัญลักษณ์สกุลเงินบาท
      }
      //สร้างอะเรย์เก็บค่าที่ต้องการใช้เอาไว้
      var TxtNumArr = new Array(
        "ศูนย์",
        "หนึ่ง",
        "สอง",
        "สาม",
        "สี่",
        "ห้า",
        "หก",
        "เจ็ด",
        "แปด",
        "เก้า",
        "สิบ"
      );
      var TxtDigitArr = new Array(
        "",
        "สิบ",
        "ร้อย",
        "พัน",
        "หมื่น",
        "แสน",
        "ล้าน"
      );
      var BahtText = "";
      //ตรวจสอบดูซะหน่อยว่าใช่ตัวเลขที่ถูกต้องหรือเปล่า ด้วย isNaN == true ถ้าเป็นข้อความ == false ถ้าเป็นตัวเลข
      if (isNaN(number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        //ตรวสอบอีกสักครั้งว่าตัวเลขมากเกินความต้องการหรือเปล่า
        if (number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          //พรากทศนิยม กับจำนวนเต็มออกจากกัน 
          number = (number + "").split(".");
          //ขั้นตอนต่อไปนี้เป็นการประมวลผล
          if(number.length === 1)
          {
            number.push('0');
          }
          else if (number[1].length > 0) {
            number[1] = number[1].substring(0, 2);
          }
          var NumberLen = number[0].length - 0;
          for (var i = 0; i < NumberLen; i++) {
            var tmp = number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ยี่";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += TxtNumArr[tmp];
              }
              BahtText += TxtDigitArr[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (number[1] == "0" || number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            const DecimalLen = number[1].length - 0;
            for (var i = 0; i < DecimalLen; i++) {
              var tmp = number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ยี่";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += TxtNumArr[tmp];
                }
                BahtText += TxtDigitArr[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          return BahtText;
        }
      }
    }
    const toDateStringThai = (txt) =>
    {  
        //console.log('toDateStringThai',txt,txt.substr(4,1));

        if(!txt)
        {
            return '';
        }
        else if(typeof txt.getMonth === 'function')
        {
            const result = txt.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
      
              return result;
        }
        else if(txt.substr(4,1) === '-')
        {
            const txts = txt.split('-');
            const date = new Date(parseInt(txts[0]), parseInt(txts[1]) - 1, parseInt(txts[2]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
    
            return result;
        }
        else if(txt && txt.length === 10)
        {
            const txts = txt.split('/');
            const date = new Date(parseInt(txts[2]), parseInt(txts[1]) - 1, parseInt(txts[0]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
    
            return result;
        }else if(txt && txt.length === 19)
        {
            const txtTs = txt.split('T');
            const txts = txtTs[0].split('-');
            const date = new Date(parseInt(txts[0]), parseInt(txts[1]) - 1, parseInt(txts[2]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })

            return result;
        }
        else{
            return '';
        }
    }

    const editChange = (text, fieldName, status) => {

        console.log('editChange',text)

        if (status === "" || status === "DRAFT" || status === "REJECT") {
            if((text ?? "").length > 60)
            {
                setEditorHtml(text);
                setStateObjAdjustment((previous)=>({...previous,[fieldName]:text}));
            }else{
                if((stateObjAdjustment.fine_adjust_template ?? "").length > 60)
                {
                    setEditorHtml(stateObjAdjustment.fine_adjust_template);
                    setStateObjAdjustment((previous)=>({...previous,[fieldName]:previous.fine_adjust_template}));

                    setTimeout(()=>{
                        setAdjustTemplateData((previous)=>({...previous,'draw':previous.draw + 1}));
                    },300)
                }
            }
        }
    };

    const handleChangeObjAdjustment = (event) => {
        //let obj = Clone(stateObjAdjustment);
        let obj = {};
        const target = event.target
        let value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value
        const name = target.name
        
        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        obj[name] = value;

        if (name === "is_sende_informal") {
            if (value == true) {
                obj["is_sende_auto"] = false;
                obj[name] = value;
            }
        }

        if (name === "is_sende_auto") {
            if (value === true) {
                obj["is_sende_informal"] = false;
                obj[name] = value;
            }
        }

        setStateObjAdjustment((previous)=>({...previous,...obj}));
        console.log("handleChangeObjAdjustment")
        //console.log(obj);

      };

    const handleTextField = (e, fieldName) => {
        let obj = Clone(stateObjAdjustment);
        obj[fieldName] = e.target.value;
        setStateObjAdjustment({...obj});
    };

    const handleSave = (event) => {
        if (stateObjAdjustment.adjustment_id == 0 && stateAdjustId == 0) {
            saveAdjustment(stateObjAdjustment);
        }
        else{
            updateAdjustment({...stateObjAdjustment});
        }
    };

    function saveAdjustment(ObjAdjustment) {

        try {

            AdjustmentService.saveAdjustment(ObjAdjustment).then((response) => {
                console.log("saveAdjustment");
                console.log(response);
            })
        } catch (e) {
            console.log(e);
        }
    }

    function updateAdjustment(objAdjustment) {
        setOpenLoading(true);
        try {

            console.log('objAdjustment.adjust_date', objAdjustment.adjust_date,  objAdjustment.adjust_date ? moment(objAdjustment.adjust_date+ ' 07:00','DD/MM/YYYY HH:mm').toDate() : null)
            objAdjustment.fine_adjust_date = objAdjustment.fine_adjust_date ? moment(objAdjustment.fine_adjust_date+' 07:00','DD/MM/YYYY HH:mm').toDate() : null;
            objAdjustment.reserved_adjust_date = objAdjustment.reserved_adjust_date ? moment(objAdjustment.reserved_adjust_date+ ' 07:00','DD/MM/YYYY HH:mm').toDate() : null;
            objAdjustment.update_date = objAdjustment.update_date ? moment(objAdjustment.update_date+ ' 07:00','DD/MM/YYYY HH:mm').toDate() : null;
            objAdjustment.create_date = objAdjustment.create_date ? moment(objAdjustment.create_date+ ' 07:00','DD/MM/YYYY HH:mm').toDate() : null;
            objAdjustment.adjust_date = objAdjustment.adjust_date ? moment(objAdjustment.adjust_date+ ' 07:00','DD/MM/YYYY HH:mm').toDate() : null;

            //objAdjustment.amount = parseFloat((objAdjustment.amount+"").replaceAll(',',''));
            objAdjustment.amount = parseFloat((objAdjustment.amount+"").split(',').join(''));

            AdjustmentService.updateAdjustment(objAdjustment).then((response) => {
                console.log("updateAdjustment");
                console.log(response);

                if(response.isSuccess == true){
                    msg.success(response.returnMessage);

                    if(objAdjustment.isSubmit)
                    {
                        history.push(`/NotiAdjustment`);
                    }else{

                    }
                    
                }
                else{
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false);
        }
    }

    function updateEditAdjustment(objAdjustment) {

        try {

            objAdjustment.fine_adjust_date = objAdjustment.fine_adjust_date ? moment(objAdjustment.fine_adjust_date).toDate() : null;
            objAdjustment.reserved_adjust_date = objAdjustment.reserved_adjust_date ? moment(objAdjustment.reserved_adjust_date).toDate() : null;
            objAdjustment.update_date = objAdjustment.update_date ? moment(objAdjustment.update_date).toDate() : null;
            objAdjustment.create_date = objAdjustment.create_date ? moment(objAdjustment.create_date).toDate() : null;
            objAdjustment.adjust_date = objAdjustment.adjust_date ? moment(objAdjustment.adjust_date).toDate() : null;

           // objAdjustment.amount = parseFloat((objAdjustment.amount+"").replaceAll(',',''));
            objAdjustment.amount = parseFloat((objAdjustment.amount+"").split(',').join(''));

            AdjustmentService.updateEditAdjustment(objAdjustment).then((response) => {
                console.log("updateEditAdjustment");
                console.log(response);
                setIsOpenEditAdjustment(false)
                if(response.isSuccess == true){
                    msg.success(response.returnMessage);

                    if(objAdjustment.isSubmit !== true)
                    {
                        GetAdjustmentById(adjustId)
                        //history.push(`/NotiAdjustmentDetail/${response.transactionNo}`);
                    }else{
                        history.push(`/NotiAdjustment`);
                    }
                    
                }else{
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
        }
    }

    
    const getDraftPDFFile = ()=>{
        
        setOpenLoading(true);
        let obj = {...adjustTemplateData,'no':stateObjAdjustment.fine_adjust_no};


        const html = stateObjAdjustment.fine_adjust_template;
//fine_adjust_draft
        AdjustmentService.getDraftPDFFile({id:adjustId,type:'',
        filename:stateObjAdjustment.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(stateObjAdjustment.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(stateObjAdjustment.mom_no),
        template:'',body:html,title:'',values:obj}).then(res=>{
            setOpenLoading(false)

        })
     }


     const getDraftPDFFileComplete = ()=>{
        setIsPrintReservedAdjust(false)
        setIsPrintAdjust(false)

        setIsOpenViewFileComplete(true);
     }

     const handleOnClickSendConfirm = ()=>{

        if (validate()) {

        }else{
            setIsOpenConfirmSend(true);
        }
        
     }

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const handleOnClickSend = () =>{

        if (validate()) {

        }
        else {
            const d = {...stateObjAdjustment,
                isSubmit: true
            };

            if (stateObjAdjustment.adjustment_id == 0) {
                saveAdjustment(d);
            }
            else {
                updateAdjustment(d);
            }
        }
    }

    const handleOnClickApproveConfirm= ()=> {
        setIsOpenConfirmApprove(true);
    }

    const handleOnClickApprove = () => {
        const _d = {...stateObjAdjustment,
            isSubmit: true,
            status:"APPROVE"
        };
        updateAdjustment(_d);
    }

    const handleOnClickRejectConfirm= ()=> {
        setIsOpenConfirmReject(true);
    }

    const handleOnClickReject = () => {

        setTimeout(() => {
            const d = {...stateObjAdjustment,
                isSubmit: true,
                status:"REJECT"
            };

            if(d.message_reject)
            {
                updateAdjustment(d);
            }
        }, 500);
    }

    const editAdjustment = () => {

        setIsOpenEditAdjustment(true)
    }

    const handleOnClickEdit = () => {
            updateEditAdjustment({...stateObjAdjustment});
    }


    function validate() {
        let checkErrors = []
        let isError = false

        if(stateObjAdjustment.department == ""){
            checkErrors.push({ error_message: "กรุณาระบุ หน่วยงาน ข้อมูลติดต่อสอบถาม" })
        }
        if(stateObjAdjustment.telephone == ""){
            checkErrors.push({ error_message: "กรุณาระบุ เบอร์โทร ข้อมูลติดต่อสอบถาม" })
        }

        if(stateObjAdjustment.is_sende_auto == false && stateObjAdjustment.is_sende_informal == false){
            checkErrors.push({ error_message: "กรุณาระบุ วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ" })
        }
        if(stateObjAdjustment.is_sende_auto == true && stateObjAdjustment.is_sende_auto_email == ""){
            checkErrors.push({ error_message: "กรุณาระบุ E-mail Vendor" })
        }else if(stateObjAdjustment.is_sende_auto == true && !validateEmail(stateObjAdjustment.is_sende_auto_email)){
            checkErrors.push({ error_message: "กรุณาระบุ E-mail Vendor ในรูปแบบ e-mail Ex: example@ptt.com" })
        }

        

        let error_messages = []
        if (checkErrors.length > 0) {
            checkErrors.forEach((error) => {
                error_messages.push(error.error_message)
            })
            isError = true
            msg.error(error_messages.join('<br/>'))
        }
        return isError
    }


    const handleOnClickPrintHasHeader = () => {
      
        setOpenLoading(true);
        
        if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
        {
            AdjustmentService.getCreatePDFAdjustmentDetail({id:adjustId,type:"fine_adjust",
            filename:stateObjAdjustment.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(stateObjAdjustment.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(stateObjAdjustment.mom_no),
            template:'adjustment'}).then((response)=>{
                setIsOpenViewFile(false);
                setOpenLoading(false)
            });
        }else{

            const html = stateObjAdjustment.fine_adjust_template;// ? stateObjAdjustment.fine_adjust_template :formFineAdjustTemplate.template;

            // for (const [key, value] of Object.entries(adjustTemplateData)) {
            //     html = html.replace('{'+key+'}',value);
            //   }

            AdjustmentService.getDraftPDFFile({'body':html,
            'filename':stateObjAdjustment.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(stateObjAdjustment.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(stateObjAdjustment.mom_no),
            template:'adjustment_draft', values: adjustTemplateData}).then((response)=>{
                setIsOpenViewFile(false);
                setOpenLoading(false)
            });
        }
    }

    const handleOnClickPrintNoneHeader = () => {
      
        setOpenLoading(true);
        
        if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
        {
            AdjustmentService.getCreatePDFAdjustmentDetail({id:adjustId,type:"fine_adjust",
            filename:stateObjAdjustment.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(stateObjAdjustment.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(stateObjAdjustment.mom_no),
            template:'adjustment_none_header'}).then((response)=>{
                setIsOpenViewFile(false);
                setOpenLoading(false)
            });
        }else{

            const html = stateObjAdjustment.fine_adjust_template;// ? stateObjAdjustment.fine_adjust_template :formFineAdjustTemplate.template;

            // for (const [key, value] of Object.entries(adjustTemplateData)) {
            //     html = html.replace('{'+key+'}',value);
            //   }

            AdjustmentService.getDraftPDFFile({'body':html,
            'filename':stateObjAdjustment.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(stateObjAdjustment.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(stateObjAdjustment.mom_no),
            template:'adjustment_draft_none_header',values:adjustTemplateData}).then((response)=>{
                setIsOpenViewFile(false);
                setOpenLoading(false)
            });
        }
    }

    function IsShowsLoading(props) {
        const { isLoading } = props;
        return (
            (isLoading ?
                <div id="loading-element">
                    <div id="loading-indicator">
                        <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                </div>
                : null)
        )
    }

    return (
        <div className="tor tor-template-list">
            <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
            <SecureGateRoute />

            <div id="main-content">
                <div className="page-body">
                    <BreadCrumb breadcrumb={[
                        { name: 'RRS Home', url: AppSettings.defaultUrl },
                        { name: 'หนังสือแจ้งค่าปรับ', url: '/NotiAdjustment' },
                        {name: '', url: ''}
                    ]}></BreadCrumb>

                    <div className="sp-page-header-panel row">
                        <div className="col-md-5 sp-page-header">
                            <h1 className="sp-page-header1">หนังสือแจ้งค่าปรับ</h1>
                        </div>
                    </div>

                    <div className="sp-page-result-container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="rrs-detail-data">
                                    <Grid container>
                                        <Grid item>
                                            <Typography  color='primary' style={{fontWeight:'bold'}}>Status:&nbsp;</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography style={{color: stateObjAdjustment.status === 'DRAFT' ? '#28a745':
                                            stateObjAdjustment.status === 'WAITFAPP' ? '#28a745':
                                            stateObjAdjustment.status === 'COMPLETE' ? '#28a745':
                                            stateObjAdjustment.status === 'REJECT' ? '#f44336': '#28a745'
                                        }}>{stateObjAdjustment.status_name}</Typography>
                                        </Grid>
                                    </Grid>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">PO/Contract No. : </label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="po_contract_no"
                                            name="po_contract_no"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            defaultValue={stateObjAdjustment.po_contract_no ?? ''}
                                            //onChange={(e) => handleTextField(e, 'po_contract_no')}
                                            //onChange={handleChangeObjAdjustment}
                                            //onBlur={handleChangeObjAdjustment}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1">
                                {/* <a onClick={handleSearch} style={{ cursor: 'pointer' }}>
                                    <i className="icon bt-search icon-xs" />
                                </a> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">ชื่องาน : </label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="po_header_text"
                                            name="po_header_text"
                                            className="form-control"
                                            defaultValue={stateObjAdjustment.po_header_text ?? ''}
                                            //value={stateObjAdjustment.po_header_text ?? ''}
                                            //onChange={handleChangeObjAdjustment}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">{stateObjAdjustment.product_type === "G" ? "หนังสือแจ้งสิทธิ์เรียกค่าปรับ ที่ :" : "หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ ที่ :"} </label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="ADJUST"
                                            name="ADJUST"
                                            className="form-control"
                                            defaultValue={stateObjAdjustment.adjust_no ?? ""}
                                            disabled={true}
                                        // value={serachConditionModel.PO_CONTRACT_NO}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">วันที่ : </label>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <DatePicker
                                                name="adjust_date"
                                                id="adjust_date"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={stateObjAdjustment.adjust_date ?? ''}
                                                //onChange={handleChangeObjAdjustment}
                                                //onBlur={handleChangeObjAdjustment}
                                                readOnly={true}
                                                disabled={true}
                                            //ref={this.create_date_from_ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">งวดที่ : </label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="INSTALLMENT"
                                                name="INSTALLMENT"
                                                className="form-control"
                                                defaultValue={stateObjAdjustment.installment_no ?? ''}
                                                disabled={true}
                                            // value={serachConditionModel.PO_CONTRACT_NO}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className={`checkboxcontainer rrs-fine-label mb-0`}> งวดสุดท้าย
                                                    <input
                                                        type="checkbox"
                                                        key={`final_installment_flag${stateObjAdjustment.adjust_no}`}
                                                        name="final_installment_flag"
                                                        //onChange={handleChangeObjAdjustment}
                                                        id="final_installment_flag"
                                                        defaultChecked={toBoolean(stateObjAdjustment.final_installment_flag)}
                                                        //checked={toBoolean(stateObjAdjustment.final_installment_flag)}
                                                        //disabled={!hasAdjustment}
                                                        disabled={true}
                                                    />
                                                    <span className="checkboxmark" />
                                                </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { stateObjAdjustment.product_type === "G" && <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ ที่ : </label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="reserved_adjust_no"
                                            name="reserved_adjust_no"
                                            className="form-control"
                                            defaultValue={stateObjAdjustment.reserved_adjust_no}
                                            disabled={true}
                                        // value={serachConditionModel.PO_CONTRACT_NO}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">วันที่ : </label>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <DatePicker
                                                name="reserved_adjust_date"
                                                id="reserved_adjust_date"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                defaultValue={stateObjAdjustment.reserved_adjust_date ?? ''}
                                                //value={stateObjAdjustment.reserved_adjust_date ?? ''}
                                                //onChange={handleChangeObjAdjustment}
                                                //onBlur={handleChangeObjAdjustment}
                                                readOnly={true}
                                                disabled={true}
                                            //ref={this.create_date_from_ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-3">
                                        {/* <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">งวดที่ : </label>
                                        </div> */}
                                    </div>
                                    <div className="col-md-3">
                                        {/* <div className="form-group">
                                            <input
                                                type="text"
                                                id="RESERVED_INSTALLMENT"
                                                name="RESERVED_INSTALLMENT"
                                                className="form-control"
                                            // value={serachConditionModel.PO_CONTRACT_NO}
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>}

                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">เหตุผลแจ้งปรับ : </label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="REMARK_ADJUST"
                                            name="REMARK_ADJUST"
                                            className="form-control"
                                            defaultValue={stateObjAdjustment.remark_adjust_text}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">คำอธิบายเพิ่มเติม : </label>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="REMARK_ADJUST_DES"
                                                name="REMARK_ADJUST_DES"
                                                className="form-control"
                                                defaultValue={stateObjAdjustment.remark_adjust_des}
                                            // value={serachConditionModel.PO_CONTRACT_NO}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    <label className="rrs-label ">หนังสือแจ้งค่าปรับ ที่ : </label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        <input
                                            type="text"
                                            id="fine_adjust_no"
                                            name="fine_adjust_no"
                                            className="form-control"
                                            defaultValue={stateObjAdjustment.fine_adjust_no}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                            <label className="rrs-label ">วันที่ : </label>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="form-group">
                                            <DatePicker
                                                name="fine_adjust_date"
                                                id="fine_adjust_date"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                defaultValue={stateObjAdjustment.fine_adjust_date ?? ''}
                                                //value={stateObjAdjustment.reserved_adjust_date ?? ''}
                                                //onChange={handleChangeObjAdjustment}
                                                //onBlur={handleChangeObjAdjustment}
                                                readOnly={true}
                                                disabled={true}
                                            //ref={this.create_date_from_ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="ข้อมูลสัญญาหรือข้อตกลง" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{paddingTop:10, paddingBottom:10}}>
                                    <React.Fragment>
                                        <Grid container justifyContent="center" style={{ height: '100%' }}>
                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">Vendor Name : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="vendor_name"
                                                                    name="vendor_name"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue={stateObjAdjustment.vendor_name ?? ''}
                                                                    //value={stateObjAdjustment.vendor_name ?? ''}
                                                                    //onChange={handleChangeObjAdjustment}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">Vendor Code : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="vendor_code"
                                                                    name="vendor_code"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue={stateObjAdjustment.vendor_code ?? ''}
                                                                    //onChange={handleChangeObjAdjustment}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">วิธีการจัดหา : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="procurement_method"
                                                                    name="procurement_method"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={stateObjAdjustment.procurement_method ?? ''}
                                                                    readOnly={true}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>

                                            <Grid item md={12} sm={12} xs={12} style={{width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">เลขที่สัญญา/ใบสั่งซื้อสั่งจ้าง/<br/>ข้อตกลงเป็นหนังสือ : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="purchase_no"
                                                                    name="purchase_no"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={stateObjAdjustment.purchase_no ?? ''}
                                                                    readOnly={true}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>

                                            <Grid item md={12} sm={12} xs={12} style={{width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">ลงวันที่ : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <DatePicker
                                                                        name="str_purchase_date"
                                                                        id="str_purchase_date"
                                                                        placeholder="dd/mm/yyyy"
                                                                        data-date-format="dd/mm/yyyy"
                                                                        value={stateObjAdjustment.str_purchase_date
                                                                            ? stateObjAdjustment.str_purchase_date
                                                                            : ""}
                                                                        //onChange={handleChangeObjAdjustment}
                                                                        //onBlur={(event) => handleChangeObjAdjustment(event, true)}
                                                                        //onBlur={handleChangeObjAdjustment}
                                                                        doctype="*"
                                                                        tagid="adjust.str_purchase_date"
                                                                        readOnly={true}
                                                                        showsdayall={"All"}
                                                                        disabled={true}
                                                                    />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>

                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">จำนวนเงินตามสัญญา : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="amount"
                                                                        name="amount"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.amount}
                                                                        //value={stateObjAdjustment.amount}
                                                                        // onChange={handleChangeSerachConditionModel}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                        style={{textAlign:'right'}}
                                                                    />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">สกุลเงิน : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                        type="text"
                                                                        id="currency"
                                                                        name="currency"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.currency}
                                                                        // value={serachConditionModel.PO_CONTRACT_NO}
                                                                        // onChange={handleChangeSerachConditionModel}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                    />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="ผู้ลงนาม" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{paddingBottom:10}}>
                                    <React.Fragment>
                                        <Grid container justifyContent="center" style={{ height: '100%' }}>
                                        <Grid item md={12} sm={12} xs={12} style={{width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">ชื่อ - นามสกุล : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="approver_name"
                                                                    name="approver_name"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={stateObjAdjustment.approver_name ?? ''}
                                                                    readOnly={true}
                                                                    disabled={!canEdit}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">ตำแหน่ง : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="approver_position"
                                                                    name="approver_position"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    value={stateObjAdjustment.approver_position ?? ''}
                                                                    readOnly={!canEdit}
                                                                    disabled={!canEdit}
                                                                    onBlur={handleChangeObjAdjustment}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="ติดต่อสอบถาม" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{paddingBottom:10}}>
                                    <React.Fragment>
                                        <Grid container justifyContent="center" style={{ height: '100%' }}>
                                        <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label "><span className="required">*</span>หน่วยงาน : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="department"
                                                                    name="department"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue={stateObjAdjustment.department ?? ''}
                                                                    onBlur={handleChangeObjAdjustment}
                                                                    readOnly={!canEdit}
                                                                    disabled={!canEdit}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label "><span className="required">*</span>เบอร์โทร : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <input
                                                                    type="text"
                                                                    id="telephone"
                                                                    name="telephone"
                                                                    className="form-control"
                                                                    placeholder=""
                                                                    defaultValue={stateObjAdjustment.telephone ?? ''}
                                                                    onBlur={handleChangeObjAdjustment}
                                                                    readOnly={!canEdit}
                                                                    disabled={!canEdit}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{paddingBottom:10}}>
                                    <React.Fragment>
                                        <Grid container justifyContent="center" style={{ height: '100%' }}>
                                        <Grid item md={12} sm={12} xs={12} style={{width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                        <label className="rrs-label "><span className="required">*</span> วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <div className="col-auto">
                                                                        <label className={`radiocontainer`}>ระบบส่งอัตโนมัติ
                                                                            <input
                                                                                key={`is_sende_auto${stateObjAdjustment.adjust_no}`}
                                                                                type="radio"
                                                                                name={"is_sende_auto"}
                                                                                checked={toBoolean(stateObjAdjustment.is_sende_auto)}
                                                                                onChange={handleChangeObjAdjustment}
                                                                                readOnly={!canEdit}
                                                                                disabled={!canEdit}
                                                                            />

                                                                            <span className="checkmark" />
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label ">{toBoolean(stateObjAdjustment.is_sende_auto) && <span className="required">*</span>}E-mail Vendor : </label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="is_sende_auto_email"
                                                                        name="is_sende_auto_email"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={stateObjAdjustment.is_sende_auto_email}
                                                                        //defaultValue={stateObjAdjustment.is_sende_auto_email}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        readOnly={!canEdit}
                                                                        disabled={toBoolean(stateObjAdjustment.is_sende_auto) ? !canEdit : true}
                                                                        maxLength={150}
                                                                        autoComplete="off"
                                                                    />
                                                                    <FormLabel className="Mui-error" style={{fontSize:11}}>กรุณาตรวจสอบความถูกต้อง ว่าเป็น e-mail ที่ผู้ค้าใช้สำหรับติดต่อกับ ปตท. ในนามผู้ค้า</FormLabel>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </Grid>

                                            </Grid>
                                            <Grid item md={12} sm={12} xs={12} style={{width: '100%', pading: 10, display: 'flex' }}>
                                                <Grid item xs={3}>
                                                    <div className="col-12">
                                                        <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                            <label className="rrs-label "></label>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                <div className="col-auto">
                                                                        <label className={`radiocontainer`}>ส่งเองนอกระบบ
                                                                            <input
                                                                                key={`is_sende_informal${stateObjAdjustment.adjust_no}`}
                                                                                type="radio"
                                                                                name={"is_sende_informal"}
                                                                                checked={toBoolean(stateObjAdjustment.is_sende_informal)}
                                                                                onChange={handleChangeObjAdjustment}
                                                                                disabled={!(stateObjAdjustment.status === '' || stateObjAdjustment.status==='DRAFT')}
                                                                            />
                                                                            <span className="checkmark" />
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <PanelExpand title="แบบฟอร์มหนังสือแจ้งค่าปรับ" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{paddingBottom:10}}>
                                    <React.Fragment>
                                        <Grid container justifyContent="center" style={{ height: '100%' }}>
                                        {console.log('stateObjAdjustment.fine_adjust_template',stateObjAdjustment.fine_adjust_template)}
                                            { stateObjAdjustment.fine_adjust_template && <PanelProductEdit 

                                            //isReadOnly={!(stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT')}
                                                name="adjust_template"
                                                id="adjust_template"
                                                template={editorHtml}
                                                data={adjustTemplateData}
                                                editChange={(text) => editChange(text, 'fine_adjust_template', stateObjAdjustment.status)}
                                                viewMode={!(canEdit)}
                                                height={1050}
                                                >
                                            </PanelProductEdit>}
                                        </Grid>
                                    </React.Fragment>
                                </PanelExpand>
                            </div>
                        </div>

                        <div className="rrs-detail py-1">
                            <div className="row sp-table-content-footer">
                                <div className="col-12 sp-header-button-panel2">
                                
                                { (stateObjAdjustment.status === 'DRAFT' 
                                        || stateObjAdjustment.status === 'WAITFAPP' 
                                        || stateObjAdjustment.status === 'REJECT'
                                        ) 
                                        &&<a className="sp-btn-icon" onClick={getDraftPDFFile}>
                                            <i className="icon btn-print-orange" />
                                            <span className="sp-btn-icon-label4">{stateObjAdjustment.status === 'COMPLETE' ? "Print": "Print Preview"}</span>
                                        </a>}

                                        { (stateObjAdjustment.status === 'COMPLETE') 
                                        &&<a className="sp-btn-icon" onClick={getDraftPDFFileComplete}>
                                            <i className="icon btn-print-orange" />
                                            <span className="sp-btn-icon-label4">{stateObjAdjustment.status === 'COMPLETE' ? "Print": "Print Preview"}</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === 'COMPLETE') 
                                        &&<a className="sp-btn-icon" onClick={editAdjustment}>
                                            <i className="icon btn-edit-blue" />
                                            <span className="sp-btn-icon-label">{"Edit"}</span>
                                        </a>}


                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === '' 
                                        || stateObjAdjustment.status === 'DRAFT'
                                        || stateObjAdjustment.status === 'REJECT') 
                                        &&<a className="sp-btn-icon" onClick={handleSave} style={{ cursor: 'pointer' }}>
                                            <i className="icon btn-order-savedraft"></i>
                                            <span className="sp-btn-icon-label">Save</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === 'DRAFT'
                                        || stateObjAdjustment.status === 'REJECT') 
                                        && <a className="sp-btn-icon" onClick={handleOnClickSendConfirm}>
                                            <i className="icon btn-order-publish" />
                                            <span className="sp-btn-icon-label3">Submit</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && ( canApprove && stateObjAdjustment.status === 'WAITFAPP') && <a className="sp-btn-icon" onClick={handleOnClickApproveConfirm}>
                                            <i className="icon btn-order-approval" />
                                            <span className="sp-btn-icon-label">Approve</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && (canApprove && stateObjAdjustment.status === 'WAITFAPP') && <a className="sp-btn-icon" onClick={handleOnClickRejectConfirm}>
                                            <i className="icon btn-order-reject" />
                                            <span className="sp-btn-icon-label">Reject</span>
                                        </a>}

                                </div>
                            </div>
                        </div>

                    </div>
                  

                <CustomDialog open={isOpenViewFileComplete} title={stateObjAdjustment.status === 'COMPLETE' ? "Print แบบฟอร์มหนังสือแจ้งค่าปรับ" :"Print Preview แบบฟอร์มหนังสือแจ้งค่าปรับ"} maxWidth="sm"
                onClose={()=>{
                    setIsOpenViewFileComplete(false)
                }}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={2}>
                        <Grid item md={6} xs={12} style={{textAlign:'center'}}>
                            <Button color="primary" variant={"contained"} style={{marginRight:5}} size="large" onClick={handleOnClickPrintHasHeader}>แบบมี Header/Footer</Button>
                        </Grid>
                        <Grid item md={6} xs={12} style={{textAlign:'center'}}>
                            <Button color="primary" variant={"contained"} size="large" onClick={handleOnClickPrintNoneHeader}>แบบไม่มี Header/Footer</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                    </Grid>
                </CustomDialog>


                <CustomDialog open={isOpenConfirmSend} title="ยืนยันส่งอนุมัติ" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmSend(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยันส่งอนุมัติ</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickSend}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmSend(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>


                <CustomDialog open={isOpenConfirmApprove} title="ยืนยันอนุมัติ" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmApprove(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยันอนุมัติ</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickApprove}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmApprove(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>

                <CustomDialog open={isOpenEditAdjustment} title="ยืนยัน Edit" maxWidth="sm"
                onClose={()=>{
                    setIsOpenEditAdjustment(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยัน Edit</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickEdit}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenEditAdjustment(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>


                

                <CustomDialog open={isOpenConfirmReject} title="Message" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmReject(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}} spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography align='right'>เหตุผล</Typography>
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <TextField
                             multiline
                             rows={4}
                             variant="outlined"
                             fullWidth
                             name="message_reject"
                             defaultValue={stateObjAdjustment.message_reject}
                             onBlur={handleChangeObjAdjustment}
                             helperText={stateObjAdjustment.message_reject ? "" : "กรุณาระบุเหตผล"}
                             error={!stateObjAdjustment.message_reject}
                             maxLength={250}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickReject}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmReject(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>
                </div>
            </div>
        </div >
    );
}